import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const AddPhoto = () => {
  const [Photo_Name, setPhotoName] = useState("");
  const [Add_Image, setAddImage] = useState(null);
  const [set_type, setImgType] = useState("");
  const navigate = useNavigate();

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setAddImage(file);
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append('Photo_Name', Photo_Name);
      formData.append('Add_Image', Add_Image);
      formData.append('set_type', set_type);

      const axiosConfig = {
        timeout: 2000,
        withCredentials: true,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      const response = await axios.post("https://api.kgphotographies.com/api/createPhoto", formData, axiosConfig);
      alert("Photo Added")
      console.log("Photo created successfully:", response.data);
      console.log("FormData:", formData);
    } catch (error) {
      console.error("Error creating photo:", error);
      alert("failed to add Photo")
    }
  };

  useEffect(() => {
    const checkSession = async () => {
      try {
        const response = await axios.get(
          "https://api.kgphotographies.com/api/protected-route",
          {
            withCredentials: true,
          }
        );
        console.log(response.data)
        // Continue with normal flow if the session is active
      } catch (error) {
        // Redirect to login page or handle the situation accordingly
        navigate("/login");
      }
    };

    checkSession();
  }, [navigate]);

  const logouthandler = (e) => {
    e.preventDefault();
    axios
        .get("https://api.kgphotographies.com/api/logout", {
        }, { withCredentials: true })
        .then((res) => {
        console.log(res);
        navigate('/')
        })
        .catch((err) => {
        console.log(err)
        });
    };

    const availability = (e) => {
      navigate("/availability")
    }

  return (
    <div>
  <header>
    <ul className="nav nav-pills nav-justified mb-3" id="ex1" role="tablist">
    <li className="nav-item" role="presentation">
      <a className="nav-link active" id="tab-login" data-mdb-toggle="pill" href="/Addphoto" role="tab"
        aria-controls="pills-login" aria-selected="true">Add Photo</a>
    </li>
    <li className="nav-item" role="presentation">
      <a className="nav-link" id="tab-register" data-mdb-toggle="pill" href="/availability" role="tab"
        aria-controls="pills-register" aria-selected="false">Add Availability</a>
    </li>
  </ul>
  </header>
      <form onSubmit={submitHandler}>
        <div>
          <div className="form-label">
            <label>
              Image Name:
              <input
                className="form-control"
                onChange={(e) => setPhotoName(e.target.value)}
                value={Photo_Name}
                name="Photo_Name"
                type="text"
              />
            </label>
          </div>


          <div className="form-fields">
            <label>
              Upload Image:
              <input
                className="form-control"
                onChange={handleFileChange}
                name="Add_Image"
                type="file"
                required
              />
            </label>
          </div>

          <div>
            <label>Select Category</label>
            <select
              className="form-select"
              onChange={(e) => setImgType(e.target.value)}
              value={set_type}
              name="set_type"
              type="text"
            >
              <option value="">Select Category</option>
              <option value="wedding">wedding</option>
              <option value="graduation">graduation</option>
              <option value="family">family</option>
            </select>
          </div>

          <button className="btn btn-info mt-3" type="submit">
            Accept
          </button>
          <div className="mt-3 me-3">
            <button className="btn btn-secondary" onClick={logouthandler}>Back</button>
          </div>
          <div>
            <button onClick={availability}>Add Available times</button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default AddPhoto;